exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".small-label[data-v-0f8e50c3]{font-size:12px}.predprosmotr-card[data-v-0f8e50c3]{padding:15px;margin:20px 0;background:hsla(0,0%,80%,.34901960784313724)}", ""]);

// exports
